import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mobile-list"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Fakturanr", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Ordrenr", -1)
const _hoisted_4 = { class: "result" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Dato", -1)
const _hoisted_6 = { class: "result" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Fakturakommentar", -1)
const _hoisted_8 = { class: "result" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Kunde", -1)
const _hoisted_10 = { class: "result" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Eks Mva", -1)
const _hoisted_12 = {
  key: 0,
  class: "result"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Mva", -1)
const _hoisted_14 = {
  key: 1,
  class: "result"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Inkl Mva", -1)
const _hoisted_16 = {
  key: 2,
  class: "result"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Fakturanr"),
    /*#__PURE__*/_createElementVNode("th", null, "Ordrenr"),
    /*#__PURE__*/_createElementVNode("th", null, "Dato"),
    /*#__PURE__*/_createElementVNode("th", null, "Fakturakommentar"),
    /*#__PURE__*/_createElementVNode("th", null, "Kunde"),
    /*#__PURE__*/_createElementVNode("th", null, "Eks Mva"),
    /*#__PURE__*/_createElementVNode("th", null, "Mva"),
    /*#__PURE__*/_createElementVNode("th", null, "Inkl Mva")
  ])
], -1)
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Link = _resolveComponent("Link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Card, null, {
      default: _withCtx(() => [
        _createVNode(_component_Pagination, {
          class: "pagination",
          paginate: _ctx.invoices,
          size: _ctx.paginationSize
        }, null, 8, ["paginate", "size"])
      ]),
      _: 1
    }),
    (_ctx.invoices?.total && _ctx.invoices.total > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoices?.data, (invoice) => {
              return (_openBlock(), _createElementBlock("li", null, [
                _hoisted_2,
                _createVNode(_component_Link, {
                  href: _ctx.route('orders.show', { order: invoice.order?.id }),
                  class: "result order-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(invoice.id), 1)
                  ]),
                  _: 2
                }, 1032, ["href"]),
                _hoisted_3,
                _createElementVNode("p", _hoisted_4, _toDisplayString(invoice.order?.id), 1),
                _hoisted_5,
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.dayjs(invoice.date).format("DD.MM.YYYY")), 1),
                _hoisted_7,
                _createElementVNode("p", _hoisted_8, _toDisplayString(invoice.order?.comment_invoice), 1),
                _hoisted_9,
                _createElementVNode("p", _hoisted_10, _toDisplayString(invoice.order?.client_model?.firstname) + " " + _toDisplayString(invoice.order?.client_model?.lastname), 1),
                _hoisted_11,
                (invoice.order?.total_ex_mva)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString((+invoice.order?.total_ex_mva).toLocaleString("nb-NO", {
                style: "currency",
                currency: "NOK",
              })), 1))
                  : _createCommentVNode("", true),
                _hoisted_13,
                (invoice.order?.total_ex_mva && invoice.order.total_inc_mva)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString((
                +invoice.order?.total_inc_mva - +invoice.order?.total_ex_mva
              ).toLocaleString("nb-NO", { style: "currency", currency: "NOK" })), 1))
                  : _createCommentVNode("", true),
                _hoisted_15,
                (invoice.order?.total_inc_mva)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString((+invoice.order?.total_inc_mva).toLocaleString("nb-NO", {
                style: "currency",
                currency: "NOK",
              })), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 256))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.invoices?.total && _ctx.invoices.total > 0)
      ? (_openBlock(), _createBlock(_component_Card, {
          key: 1,
          class: "desktop-table"
        }, {
          default: _withCtx(() => [
            _createElementVNode("table", null, [
              _hoisted_17,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoices?.data, (invoice) => {
                  return (_openBlock(), _createElementBlock("tr", null, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_Link, {
                        class: "order-link",
                        href: _ctx.route('orders.show', { order: invoice.order?.id })
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(invoice.id), 1)
                        ]),
                        _: 2
                      }, 1032, ["href"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_Link, {
                        class: "order-link",
                        href: _ctx.route('orders.show', { order: invoice.order?.id })
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(invoice.order?.id), 1)
                        ]),
                        _: 2
                      }, 1032, ["href"])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(_ctx.dayjs(invoice.date).format("DD.MM.YYYY")), 1),
                    _createElementVNode("td", null, _toDisplayString(invoice.order?.comment_invoice), 1),
                    _createElementVNode("td", null, _toDisplayString(invoice.order?.client_model?.firstname) + " " + _toDisplayString(invoice.order?.client_model?.lastname), 1),
                    (invoice.order?.total_ex_mva)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_18, _toDisplayString((+invoice.order?.total_ex_mva).toLocaleString("nb-NO", {
                  style: "currency",
                  currency: "NOK",
                })), 1))
                      : _createCommentVNode("", true),
                    (invoice.order?.total_ex_mva && invoice.order.total_inc_mva)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_19, _toDisplayString((
                  +invoice.order?.total_inc_mva - +invoice.order?.total_ex_mva
                ).toLocaleString("nb-NO", {
                  style: "currency",
                  currency: "NOK",
                })), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("td", null, _toDisplayString((+(invoice.order?.total_inc_mva ?? 0)).toLocaleString("nb-NO", {
                  style: "currency",
                  currency: "NOK",
                })), 1)
                  ]))
                }), 256))
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_Card, null, {
      default: _withCtx(() => [
        _createVNode(_component_Pagination, {
          class: "pagination",
          paginate: _ctx.invoices,
          size: _ctx.paginationSize
        }, null, 8, ["paginate", "size"])
      ]),
      _: 1
    })
  ]))
}